import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AppLauncher, showInfoDialog, Device } from '@fe_utils/fe_sdk_base';
import _ from 'lodash';
import { findAppDetailByAppName } from '../pages/AppDetail/config';

const AwardCard = ({ name, device, gold }) => {
  return (
    <AwardWrapper style={{ width: gold && '100%' }}>
      {gold && <img className='gold_crown' src={require('./images/golden_crown.png')} alt='' />}
      <div className='content'>
        <img
          className='crown'
          src={require(`./images/${gold ? 'golden' : 'black'}_crown_left.png`)}
          alt=''
        />
        <div className='award' style={{ color: gold ? '#CFBB8F' : '#2C2E34' }}>
          <span className='name'>{name}</span>
          <span className='device'>{device}</span>
        </div>
        <img
          className='crown'
          src={require(`./images/${gold ? 'golden' : 'black'}_crown_right.png`)}
          alt=''
        />
      </div>
    </AwardWrapper>
  );
};

const AwardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  > .gold_crown {
    width: 10px;
  }
  > .content {
    display: flex;
    justify-content: center;
    align-items: center;
    > .crown {
      width: 13px;
    }
    > .award {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      > .name {
        margin-top: 3px;
        font-weight: 400;
        font-size: 10px;
        line-height: 14px;
      }
      > .device {
        margin-top: 2px;
        font-weight: 400;
        font-size: 6px;
        line-height: 8px;
      }
    }
  }
`;

const ProductCard = ({
  appIcon,
  appName,
  appIntro,
  scheme,
  rateNumbers,
  rate,
  awards,
  comments,
  blank,
  style,
}) => {
  const appLauncher = useRef(null);
  // 已经配了静态详情页的 App，名称改成站内链接，方便爬虫顺着产品卡发现 /app/<关键字>.html
  const detailPage = findAppDetailByAppName(appName);

  useEffect(() => {
    appLauncher.current = new AppLauncher(scheme);
  }, [scheme]);

  const openApp = () => {
    appLauncher.current.openAppWithMarketLink((result) => {
      if (!result) {
        showInfoDialog({
          title: '跳转失败',
          message: `请手动前往${Device.isIOS ? 'App Store' : '应用商店'}搜索「${appName}」下载`,
        });
      }
    });
  };

  return (
    <Wrapper style={{ opacity: blank ? 0 : 1, ...style }}>
      <img className='app_icon' src={appIcon} alt={`${appName} App 图标`} />
      <h3 className='app_name'>
        {detailPage ? (
          <Link to={detailPage.pathname} title={`查看${appName}官网详情页`}>
            {appName}
          </Link>
        ) : (
          appName
        )}
      </h3>
      <div className='app_intro'>{appIntro}</div>
      <div className='button' onClick={openApp}>
        下载
      </div>
      <div className='details'>
        <div className='rate_content'>
          <div className='rate_title'>商店评分</div>
          <div className='rate'>{rate}</div>
          <div className='start'>
            <img src={require('./images/start.png')} alt='' />
            <img src={require('./images/start.png')} alt='' />
            <img src={require('./images/start.png')} alt='' />
            <img src={require('./images/start.png')} alt='' />
            <img src={require('./images/start.png')} alt='' />
          </div>
          <div className='rate_numbers'>{rateNumbers}</div>
        </div>
        <div className='awards_content'>
          {_.size(awards) > 0 && <div className='awards_title'>获得奖项</div>}
          <div className='awards'>
            {_.map(awards, (item, index) => (
              <AwardCard key={index} name={item.name} device={item.device} gold={item.gold} />
            ))}
          </div>
        </div>
      </div>
      <div className='user_comments'>用户评价</div>
      {_.map(comments, (item, index) => (
        <div className='comment' key={index}>
          {item}
        </div>
      ))}
    </Wrapper>
  );
};

export default ProductCard;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 260px;
  height: 430px;
  padding: 0 15px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(101, 43, 0, 0.08);
  border-radius: 14px;
  > .app_icon {
    margin-top: 26px;
    width: 54px;
  }
  > .app_name {
    /* 现在是 h3，需覆盖 base.css 给标题加的默认外边距 */
    margin: 6px 0 0;
    font-weight: 500;
    font-size: 17px;
    color: #2c2e34;
    line-height: 24px;
    > a {
      color: inherit;
      text-decoration: none;
    }
    > a:hover {
      text-decoration: underline;
    }
  }
  > .app_intro {
    margin-top: 2px;
    font-weight: 400;
    font-size: 11px;
    color: #2c2e34;
    line-height: 16px;
    /* 禁止换行 */
    white-space: nowrap;
    /* overflow: hidden;
    text-overflow: ellipsis; */
  }
  > .button {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 77px;
    height: 30px;
    background: #2c2e34;
    border-radius: 20px;
    font-weight: 500;
    font-size: 13px;
    color: #ffffff;
    text-align: center;
  }
  > .details {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    border-top: 0.5px solid rgba(44, 46, 52, 0.1);
    border-bottom: 0.5px solid rgba(44, 46, 52, 0.1);
    width: 100%;
    height: 94px;
    > .rate_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 8px;
      > .rate_title {
        margin-top: 8px;
        font-weight: 400;
        font-size: 9px;
        color: rgba(44, 46, 52, 0.6);
      }
      > .rate {
        margin-top: 10px;
        font-weight: 500;
        font-size: 16px;
        color: #2c2e34;
      }
      > .start {
        display: flex;
        margin-top: 2px;
        > img {
          margin-right: 4px;
          width: 10px;
        }
        > img:last-child {
          margin-right: 0;
        }
      }
      > .rate_numbers {
        margin-top: 4px;
        font-weight: 400;
        font-size: 8px;
        color: #8b8d92;
      }
    }
    > .awards_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      > .awards_title {
        margin-top: 7px;
        font-weight: 400;
        font-size: 9px;
        color: rgba(44, 46, 52, 0.6);
        line-height: 13px;
      }
      > .awards {
        margin: 0 5px;
        width: 152px;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
      }
    }
  }
  > .user_comments {
    margin-top: 10px;
    width: 100%;
    font-weight: 500;
    font-size: 11px;
    color: #2c2e34;
    line-height: 16px;
  }
  > .comment {
    margin: 12px 0 0 4px;
    width: 100%;
    text-align: left;
    font-weight: 400;
    font-size: 8px;
    color: #2c2e34;
    line-height: 11px;
    text-align: justify;
  }
`;
